import { logEvent } from "firebase/analytics";
import { analytics } from "lib/firebase";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const usePageView = (screenName: string) => {
  const location = useLocation();

  useEffect(() => {
    logEvent(analytics, "page_view", {
      page_title: screenName,
      page_location: window.location.href,
      page_path: location.pathname,
    });
  }, [location.pathname, screenName]);
};
